import {
  GET_LIST_DANHSACHTHANHLY,
  GET_LIST_DANHSACHTHANHLY_SUCCESS,
  GET_LIST_DANHSACHTHANHLY_FAILURE,
  UPDATE_DANHSACHTHANHLY,
} from "../../actions/DanhSachThanhLy/actionTypes";

const initialState = {
  List: [],
  TotalTienThanhLy: 0,
  TotalTienChenhLech: 0,
  TotalQuantity: 0,
};
const getListDanhSachThanhLy = (state, action) => ({
  ...state,
  getListDanhSachThanhLyLoading: true,
});

const getListDanhSachThanhLySuccess = (state, action) => {
  return {
    ...state,
    List: action.payload.List,
    TotalQuantity: action.payload.TotalQuantity,
    TotalTienChenhLech: action.payload.TotalTienChenhLech,
    TotalTienThanhLy: action.payload.TotalTienThanhLy,
    getListDanhSachThanhLyLoading: false,
  };
};

const updateListDanhSachThanhLy = (state, action) => {
  return {
    ...state,
    List: action.payload.List,
  };
};

const getListDanhSachThanhLyFailed = (state, action) => ({
  ...state,
  getListDanhSachThanhLyLoading: false,
  List: [],
});
export const listDanhSachThanhLyReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_DANHSACHTHANHLY:
      return getListDanhSachThanhLy(state, action);
    case GET_LIST_DANHSACHTHANHLY_SUCCESS:
      return getListDanhSachThanhLySuccess(state, action);
    case GET_LIST_DANHSACHTHANHLY_FAILURE:
      return getListDanhSachThanhLyFailed(state, action);
    case UPDATE_DANHSACHTHANHLY:
      return updateListDanhSachThanhLy(state, action);
    default:
      return state;
  }
};

export default listDanhSachThanhLyReducer;
